import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnDestroy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { DialogRef } from '@rd/popup/dialog-ref';
import { LogoutUser } from '../../auth/store/actions/auth.actions';
import { CoreState } from '../../store/reducers';

@Component({
  selector: 'rd-core-auth-error-message-dialog',
  templateUrl: './auth-error-message-dialog.component.html',
  styleUrls: ['./auth-error-message-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AuthErrorMessageDialogComponent implements OnDestroy {
  @HostBinding('class.rd-core-auth-error-message-dialog.component')
  componentClass = true;

  constructor(
    private dialogRef: DialogRef,
    private store: Store<{ core: CoreState }>,
  ) {}

  ngOnDestroy(): void {
    this.logoutUser();
  }

  close(): void {
    this.dialogRef.close();
  }

  private logoutUser(): void {
    this.store.dispatch(new LogoutUser());
  }
}
